import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { App, Button, Card, Space } from 'antd';
import { TagsOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import PageHeader from 'components/headings/PageHeader';
import ComponentTypesContent from 'pages/liftlogic/v2/Components/ComponentTypesContent';

function TenantComponentTypesPage() {
  const { tenantId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const tenantName = location.state?.tenantName || `Tenant ${tenantId}`;

  return (
    <App>
      <div style={{ padding: 16 }}>
        <PageHeader
          icon={TagsOutlined}
          title="Tipos de componente"
          subtitle={`Tenant: ${tenantName}`}
          actions={
            <Space>
              <Button
                icon={<ArrowLeftOutlined />}
                onClick={() =>
                  navigate(`/admin/tenants/${tenantId}/edit`, { state: location.state })
                }
              >
                Volver al tenant
              </Button>
            </Space>
          }
        />
        <Card>
          <ComponentTypesContent />
        </Card>
      </div>
    </App>
  );
}

export default TenantComponentTypesPage;
